import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../utils/helpers';

const UpdateReferenceMutation = input =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation UpdateReferenceMutation($input: UpdateReferenceInput!) {
          updateReference(input: $input) {
            updatedReference {
              id
              title
              description
            }
          }
        }
      `,
      variables: {
        input
      },
      onCompleted: resolve,
      onError: reject
    });
  });

export default UpdateReferenceMutation;
